import type {HighlightCard} from '../types';

/** Shared highlight card for the resource pages, until a site sets its own or turns it off. */
export const DEFAULT_HIGHLIGHT: HighlightCard = {
  title: 'Clever Health — Smart Virtual Care',
  body: 'All medical plans include $0-copay 24/7 virtual urgent care through the <app>Clever Health app</app> — cold/flu, allergy, eye/ear/mouth, injuries, medication refills, and more.',
  closing: 'Download the <app>Clever Health app</app> on iOS or Android to get started.',
};

/** Omitted = the shared default; null = the site turned the card off. */
export function siteHighlight(card: HighlightCard | null | undefined): HighlightCard | undefined {
  return card === undefined ? DEFAULT_HIGHLIGHT : (card ?? undefined);
}
